// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3S0k7","box":"box__O5bS0","window":"window__2BkFX"};